module.exports = __webpack_public_path__ + "img/thumbnail_RingTailedLemur_m_albino.7111cbad.png";